import React, { useState } from "react";
import { images } from "../../../data/content";
import { Modal } from "./cmsShared";
import { useMedia, UploadButton, MediaTile } from "./MediaGrid";

const SITE_KEYS = ["heroHall", "templeInterior", "squareCompass", "oldSingapore", "charity"];

export default function MediaPicker({ kind = "image", onPick, onClose }) {
  const { items, load } = useMedia();
  const [tab, setTab] = useState("library");
  const [err, setErr] = useState("");
  const list = (items || []).filter((m) => kind === "any" || m.kind === kind);

  return (
    <Modal title={kind === "image" ? "Choose an image" : "Choose a file"} onClose={onClose} wide testid="media-picker">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex gap-2">
          {["library", ...(kind === "image" ? ["site"] : [])].map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`rounded-full px-4 py-1.5 font-sans text-xs font-semibold uppercase tracking-widest transition-colors ${
                tab === t ? "bg-sapphire-deep text-parchment" : "bg-sapphire-deep/5 text-sapphire-deep hover:bg-sapphire-deep/10"
              }`}
              data-testid={`media-picker-tab-${t}`}
            >
              {t === "library" ? "Media library" : "Site images"}
            </button>
          ))}
        </div>
        {tab === "library" && (
          <UploadButton
            accept={kind === "image" ? "image/*" : undefined}
            onUploaded={() => load()}
            onError={setErr}
            testid="media-picker-upload"
          />
        )}
      </div>
      {err && <p className="mb-3 font-sans text-sm text-garnet" data-testid="media-picker-error">{err}</p>}
      {tab === "site" ? (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
          {SITE_KEYS.map((k) => (
            <button key={k} onClick={() => onPick({ ref: k, name: k })} className="overflow-hidden rounded-xl border border-sapphire-deep/10 transition-shadow hover:shadow-heritage" data-testid={`site-image-${k}`}>
              <img src={images[k]} alt={k} className="aspect-[4/3] w-full object-cover" />
              <p className="p-2 text-left font-sans text-xs text-stonegrey">{k}</p>
            </button>
          ))}
        </div>
      ) : list.length === 0 ? (
        <p className="py-10 text-center font-sans text-sm text-stonegrey" data-testid="media-picker-empty">
          {items ? "Nothing here yet — upload a file to get started." : "Loading…"}
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {list.map((m) => (
            <MediaTile key={m.id} m={m} onClick={() => onPick({ ref: `media:${m.id}`, name: m.filename, media: m })} />
          ))}
        </div>
      )}
    </Modal>
  );
}
